export const ENTER_PRIVATE_TCHAT = 'enter_private_tchat';
export const LOAD_FIRST_TIME = "load_first_time"
export const OPEN_MENU = "open_menu";
export const SET_NOTIFICATION = "set_notification";